var _a, _b;
import { FS_GATEWAY_HOST } from "../../../api/fs/constants";
export var BUSINESS_API = "".concat(FS_GATEWAY_HOST).concat((_a = process.env.BUSINESS_API) !== null && _a !== void 0 ? _a : "");
export var BUSINESS_API_V2 = "".concat(FS_GATEWAY_HOST).concat((_b = process.env.BUSINESS_API_V2) !== null && _b !== void 0 ? _b : "");
